import { defineMessages } from 'react-intl'

export default defineMessages({
  step: {
    id: 'simplestepper.step',
    defaultMessage: 'Step {activeStep} of {stepsLength}',
  },
})
